import { create, v, w } from '@dojo/framework/core/vdom';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';

import { Radio } from '@dojo/widgets/radio';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { createNlsMiddleware, lccstate, userstate, quizPatternChangeProcess } from 'lcc-state';
import { publish } from '@holmescorp/pub-sub';

import css from '../css/heading.m.css';

interface QuizChoiceIcache {
	choiceSelected: DNode;
	timing: number | null;
}

const nls = createNlsMiddleware('settings');
const factory = create({
	icache: createICacheMiddleware<QuizChoiceIcache>(),
	theme,
	nls,
	lccstate,
	userstate
});

export const QuizChoice = factory(({ middleware: { icache, theme, nls, lccstate, userstate } }) => {
	const {
		messages: {
			fieldset_selectone = '[settings] fieldset_selectone',
			selection_blocked = '[settings] selection_blocked'
		}
	} = nls();

	const themeCss = theme.classes(css);
	const choiceSelected = icache.getOrSet('choiceSelected', () =>
		v('div', { key: 'hidden', classes: [themeCss.quizSelectHidden] }, [` `])
	);
	icache.getOrSet('timing', null);

	const { get, path } = lccstate;
	const quizRunning: boolean = get(path('quizRunning'));
	const quizpatterns = get(path('quizpatterns'));
	const { get: uget, path: upath } = userstate;
	const quizPattern = uget(upath('quizPattern'));

	const choiceChanged = (quizPattern: string) => {
		let timing = icache.get('timing');
		if (timing !== null) {
			clearTimeout(timing);
			timing = null;
		}
		timing = setTimeout(() => {
			icache.set('choiceSelected', v('div', { key: 'hidden', classes: [themeCss.quizSelectHidden] }, [` `]));
		}, 6000);

		icache.set(
			'choiceSelected',
			v('div', { key: timing, classes: [themeCss.quizSelectChoice] }, [`${quizPattern} selected`])
		);
		icache.set('timing', timing);
	};

	const values: string[] = quizpatterns ? Object.keys(quizpatterns).sort() : [];
	const radios: DNode[] = values.map((value) => {
		return w(
			Radio,
			{
				key: value,
				checked: value === quizPattern,
				disabled: quizRunning,
				value,
				name: 'quiz-select',
				onValue: (checked) => {
					if (checked) {
						userstate.run(quizPatternChangeProcess)({ quizPattern: value });
						publish('change:quizpattern', value);
						choiceChanged(value);
					}
				}
			},
			[{ label: quizpatterns![value] }]
		);
	});

	return v('div', { classes: [themeCss.quizSelectBlock] }, [
		v('fieldset', {}, [v('legend', {}, [fieldset_selectone]), ...radios]),
		quizRunning
			? v('p', {}, [
					/*`This selection can be changed after leaving the quiz in progress`*/
					selection_blocked
			  ])
			: null,
		choiceSelected
	]);
});

export default QuizChoice;
